import React from 'react';
import './styles/WhatsAppButton.css';

const WhatsAppButton = () => {
    return (
        <a href="https://wa.me/+94770555783" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
            <img src="https://img.icons8.com/?size=100&id=964RahB4l606&format=png&color=000000" alt="WhatsApp"/>
        </a>
    );
};

export default WhatsAppButton;